module.exports = __webpack_public_path__ + "static/media/icon-estructuras.368a723c.svg";